'use client';
import { useState } from 'react';
import styles from '../../../page.module.scss';
import PrimaryButton from '../../buttons/PrimaryButton';
import Link from 'next/link';
import BookCard from './BookCard';

interface AuthorProps {
  mainTitle: string;
  cardImage: string;
  description?: any;
  customColor?: string;
  stayOpen?: boolean;
  desciption?: any;
  books?: any[];
}

const AuthorCard: React.FC<AuthorProps> = ({
  mainTitle,
  cardImage,
  description,
  customColor,
  stayOpen,
  books,
}) => {
  const [open, setOpen] = useState(stayOpen ? true : false);

  const otherBooks = books?.filter((book: any) => book.authors.includes(mainTitle)) || [];

  return (
    <div className={styles.authorCardContainer}>
      <div
        onClick={() => !stayOpen && setOpen(!open)}
        className={`${styles.autorCard} ${!stayOpen && styles.cardDynamic}`}
      >
        <img
          className={`${styles.imgAutor}  ${open && styles.imgSelected}`}
          id={mainTitle}
          src={cardImage}
          alt={`foto de ${mainTitle}`}
        />
        <h3 style={{ color: customColor }}>{mainTitle}</h3>
      </div>
      {open && (
        <div
          className={`${styles.oneArticleContent} ${styles.libroContent} ${styles.authorContent}`}
        >
          <div style={{ paddingBottom: '2rem' }}>
            <div className={styles.oneArticleContent}>
              <div dangerouslySetInnerHTML={{ __html: description }} />
            </div>

            {!stayOpen && (
              <div>
                <h3>Libros publicados:</h3>
                <br />
                {otherBooks?.map((book, index) => (
                  <Link key={index} href={`/libros/${book.slug}`}>
                    <BookCard
                      title={book.title}
                      image={book.cardImage}
                      authors={book.authors}
                      id={book.id}
                    />{' '}
                    <br />
                  </Link>
                ))}
              </div>
            )}
            {!stayOpen && (
              <Link href={`#${mainTitle}`}>
                <PrimaryButton text="cerrar" primary={true} onClick={() => setOpen(!open)} />
              </Link>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default AuthorCard;
